<i18n src="@/locales/modules/ActivityTranslate.json"></i18n>
<template>
	<div class="list-activities">
		<div class="header">
			<h4 class="header__title">Lịch sử hoạt động</h4>
		</div>
		<vs-button class="w-48 font-bold block ml-auto" type="border" @click="toggleFilterDialog(true)">{{ $t("Filter") }}</vs-button>
		<div class="flex gap-5 mt-5 flex-wrap justify-center items-center">
			<div class="history__controls">
				<chevron-left-icon
					size="1.5x"
					class="history__controls__button"
					@click="changeDate(-1)"
				></chevron-left-icon>
				<span class="history__controls__date">{{ formatDate(filters.DateStart) }}</span>
				<chevron-right-icon
					size="1.5x"
					:class="[
				'history__controls__button',
				{ 'history__controls__button--disabled': isNextDate() },
				]"
					@click="!isNextDate() && changeDate(1)"
				></chevron-right-icon>
			</div>
			<vs-input
				@input="() => { currentPage = 1; getActivityHistory(); }"
				class="md:ml-auto ml-0 md:order-0 order-1 w-20"
				:placeholder="'Số lượng'"
				v-model="limit"
			/>
			<vs-input
				class="ml-0 md:order-0 order-1"
				icon="search"
				:placeholder="'Nhập tên'"
				v-model="filters.PersonName"
			/>
		</div>

		<div class="flex justify-center text-lg font-bold px-6 mt-3">
			{{ `Hiển thị ${limit} trong tổng số ${totalActivities}` }}
		</div>

		<cbs-pagination
			class="mt-3"
			:total="totalPages"
			v-model="currentPage"
			v-if="activityHistory && activityHistory.length"
		/>

		<activity-table class="px-6" :isQuickMode="true" :data="activityHistory" @onSortChange="handleSortChange" />
		<activity-filter
			ref="activityFilters"
			v-model="filters"
			:isDialogActive="showFilterDialog"
			@closeDialog="toggleFilterDialog"
			@onApplyFilter="handleApplyFilter"
		/>
	</div>
</template>

<script>
import ActivityTable from "@/components/cbs-activity/ActivityTable";
import {ChevronLeftIcon, ChevronRightIcon} from "vue-feather-icons";
import axios from "axios";
import ActivityFilter from "./ActivityFilter.vue";

export default {
	name: "ActivityManagement",
	components: {
		ActivityFilter,
		ActivityTable,
		ChevronLeftIcon,
		ChevronRightIcon,
	},
	data() {
		const today = new Date();
		return {
			limit: 20,
			currentPage: 1,
			totalActivities: 0,
			activityHistory: [],
			showFilterDialog: false,
			filters: {
				EventType: "Face",
				IsInRoi: true,
				DateStart: new Date(
					today.getFullYear(),
					today.getMonth(),
					today.getDate(),
					0,
					0,
					0
				),
				DateEnd: new Date(
					today.getFullYear(),
					today.getMonth(),
					today.getDate() + 1,
					0,
					0,
					0
				),
				StartIndex: this.limit * (this.currentPage - 1),
				EndIndex: this.limit * this.currentPage,
				HourOffset: 7,
				SortBy: "time",
				SortDirection: "desc",
				PersonID: null,
				PersonName: null,
				Classification: null,
				ConfMax: null,
				ConfMin: null,
				Department: null,
				TopicID: null,
			},
		};
	},
	computed: {
		totalPages() {
			return Math.ceil(this.totalActivities / this.limit);
		},
	},
	watch: {
		currentPage() {
			this.getActivityHistory();
		},
		$route(newVal, oldVal) {
			const today = new Date();
			const newValClone = Object.assign({}, newVal);
			const oldValClone = Object.assign({}, oldVal);
			if (newValClone.path !== oldValClone.path) {
				this.$refs.activityFilters.handleResetLocalFilter();
				this.filters = {
					EventType: "Face",
					IsInRoi: true,
					DateStart: new Date(
						today.getFullYear(),
						today.getMonth(),
						today.getDate(),
						0,
						0,
						0
					),
					DateEnd: new Date(
						today.getFullYear(),
						today.getMonth(),
						today.getDate() + 1,
						0,
						0,
						0
					),
					StartIndex: this.limit * (this.currentPage - 1),
					EndIndex: this.limit * this.currentPage,
					HourOffset: 7,
					SortBy: "time",
					SortDirection: "desc",
					PersonID: null,
					PersonName: null,
					Classification: null,
					ConfMax: null,
					ConfMin: null,
					Department: null,
				};
			}
		},
		"$route.query"() {
			this.getActivityHistory();
		},
	},
	methods: {
		isNextDate() {
			const today = new Date();
			today.setDate(today.getDate());
			return this.filters.DateEnd >= today;
		},
		formatDate(date) {
			return `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
		},
		formatAPIDate(date) {
			return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
				date.getDate()
			).padStart(2, "0")} 00:00:00`;
		},
		formatDetectTime(detectTime) {
			const date = new Date(detectTime);
			date.setHours(date.getHours() - 7); // Chuyển từ GMT sang UTC+7
			const formattedDate = date.toLocaleString("vi-VN", {
				hour: "2-digit",
				minute: "2-digit",
				second: "2-digit",
			});
			return formattedDate.replace(", ", " ");
		},
		async getActivityHistory() {
			try {
				this.$vs.loading();

				// Loại bỏ các key có giá trị là null trong filters
				const filtersWithoutNull = Object.fromEntries(
					Object.entries(this.filters).filter(([_, value]) => value !== null)
				);

				const response = await axios.post("https://canhbaosom.com/ktx-camera-api", {
					url: this.$constant.API_URL_CAMERA_CMD + "/events",
					params: {
						...filtersWithoutNull,
						DateStart: this.formatAPIDate(this.filters.DateStart),
						DateEnd: this.formatAPIDate(this.filters.DateEnd),
						StartIndex: this.limit * (this.currentPage - 1),
						EndIndex: this.limit * this.currentPage,
					},
				});
				this.activityHistory = response.data.Records || [];
				this.totalActivities = response.data.TotalRecords || 0;
				this.$vs.loading.close();
			} catch (error) {
				console.error("Error fetching activity history:", error);
			}
		},
		changeDate(dayOffset) {
			this.filters.DateStart.setDate(this.filters.DateStart.getDate() + dayOffset);
			this.filters.DateEnd.setDate(this.filters.DateEnd.getDate() + dayOffset);
			this.getActivityHistory();
		},
		handleSortChange(sortKey) {
			if (this.filters.SortBy === sortKey) {
				this.filters.SortDirection = this.filters.SortDirection === 'asc' ? 'desc' : 'asc';
			} else {
				this.filters.SortBy = sortKey;
				this.filters.SortDirection = 'asc';
			}
			this.currentPage = 1;
			this.getActivityHistory();
		},
		toggleFilterDialog(val = false) {
			this.showFilterDialog = val;
		},
		handleApplyFilter(data) {
			this.filters = Object.assign(this.filters, data);
			this.currentPage = 1;
			this.getActivityHistory();
		},
	},
	mounted() {
		this.getActivityHistory();
	}
};
</script>

<style lang="scss">
.vs-icon {
	border: none !important;
}

.history {
	&__controls {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 10px auto 0;
		gap: 1rem;

		&__button {
			display: flex;
			justify-content: center;
			align-items: center;
			border: 2px solid #000000;
			color: #000000;
			border-radius: 50%;
			cursor: pointer;
			width: 21px;
			height: 21px;

			&--disabled {
				border-color: #cccccc;
				color: #cccccc;
				cursor: not-allowed;
			}

			&:hover {
				opacity: 0.8;
			}
		}

		&__date {
			font-size: 1.25rem;
			font-weight: 700;
			color: #111827;
		}
	}
}
</style>
